var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 24,
    viewBox: "0 0 42 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_353_12558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.3715 10.1054V15.973H40.2237V11.857H38.1556V15.973H36.0078V10.105H42.3715V10.1054Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5936 16.1824C33.5163 16.1824 34.9441 15.0324 34.9441 13.289C34.9441 11.6016 33.8907 10.506 32.1302 10.506C31.3177 10.506 30.6473 10.785 30.1423 11.2664C30.2628 10.2714 31.1254 9.545 32.075 9.545C32.2942 9.545 33.9442 9.5416 33.9442 9.5416L34.8772 7.7998C34.8772 7.7998 32.8057 7.8458 31.8427 7.8458C29.6424 7.8832 28.1562 9.8342 28.1562 12.2038C28.1562 14.9644 29.6057 16.1824 31.5936 16.1824ZM31.6053 12.0488C32.3192 12.0488 32.8141 12.5064 32.8141 13.2888C32.8141 13.993 32.3744 14.5732 31.6053 14.5748C30.8697 14.5748 30.3748 14.0372 30.3748 13.3008C30.3748 12.5182 30.8697 12.0488 31.6053 12.0488Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4097 14.0085C26.4097 14.0085 25.9024 14.2937 25.1449 14.3477C24.274 14.3729 23.498 13.8363 23.498 12.8829C23.498 11.9529 24.1827 11.4199 25.1229 11.4199C25.6995 11.4199 26.4621 11.8097 26.4621 11.8097C26.4621 11.8097 27.0202 10.8107 27.3093 10.3111C26.7799 9.91968 26.0749 9.70508 25.2548 9.70508C23.1851 9.70508 21.582 11.0215 21.582 12.8711C21.582 14.7443 23.0887 16.0301 25.2548 15.9913C25.8602 15.9693 26.6955 15.7619 27.2045 15.4429L26.4097 14.0085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.22412L2.97936 10.4191V13.5879L0.00348536 18.7727L0 5.22412Z",
    fill: "#5B57A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4375 8.5284L14.2293 6.8592L19.9428 6.854L11.4375 11.9368V8.5284Z",
    fill: "#D90751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4237 5.1934L11.4395 12.0714L8.45312 10.2814V0L11.4237 5.1934Z",
    fill: "#FAB718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9448 6.8542L14.231 6.8594L11.4237 5.1934L8.45312 0L19.9448 6.8542Z",
    fill: "#ED6F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4395 18.8015V15.4645L8.45312 13.7085L8.45477 24.0001L11.4395 18.8015Z",
    fill: "#63B22F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2244 17.1475L2.97916 10.4191L0 5.22412L19.9327 17.1407L14.2244 17.1475Z",
    fill: "#1487C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45312 24L11.4374 18.8014L14.2222 17.1474L19.9306 17.1406L8.45312 24Z",
    fill: "#017F36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 18.7726L8.47804 13.7086L5.62907 12.0034L2.97978 13.5878L0.00390625 18.7726Z",
    fill: "#984995"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_353_12558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpb);
export default __webpack_public_path__ + "static/media/spb.b299ddc6aefd4377084a2d64bbdd4486.svg";
export { ForwardRef as ReactComponent };